export const CONTACT_EMAIL = {
  AU: "carbonprojectsaus@loambio.com",
  US: "secondcrop.us@loambio.com",
};

export const THEME_COLORS = {
  loamGreen: "#4f9a3d",
  loamGreenLight: "#50bb33",
  loamGreenDark: "#01403a",
  loamBeige1: "#d3c4af",
  loamBeige2: "#e9e1d7",
  loamBeige3: "#4f40eb",
} as const;

export const SMALL_SCREEN_WIDTH = 768;
export const LARGE_SCREEN_WIDTH = 1024;
export const SIDEBAR_WIDTH = 225;
export const HEADER_HEIGHT = 38;
export const HEADER_HEIGHT_ONBOARDING = 64;

export const CROP_YEAR = 2027;
// This will need to be manually bumped every year, when the team is ready for
// the next year's cohort to start onboarding
export const ONBOARDING_YEAR = CROP_YEAR;
